import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'whatsapp-fixed',
  templateUrl: './whatsapp-fixed.component.html',
  styleUrls: ['./whatsapp-fixed.component.scss']
})
export class WhatsappFixedComponent implements OnInit {

  public prefixo:any   = "web"; 
  public configuration:any = null;

  constructor(
    public storage: StorageService,
    public app: AppService
  ) { 

    this.configuration = this.storage.getConfiguration();

  }

  /**
   * 
   * Open
   * 
   */
  open(){

    this.prefixo = !this.app.isMobile() ? "web" : "api";

    let telefone = this.configuration.contact_whatsapp.replace("(","").replace(")","").replace("-","").replace(" ","");
    let numero = "55"+telefone;

    window.open("https://"+this.prefixo+".whatsapp.com/send?phone="+numero,"__blank");
    

  }
  /**
   * 
   * Open
   * 
   */
  ngOnInit(): void {
    
  }

}
